import { Branding } from "../types/Branding";
import { axiosWithoutAuth } from "../utils/customAxios";

const brandingService = {
  fetchBranding: async (appUrl: string): Promise<Branding> => {
    try {
      const response = await axiosWithoutAuth.get(
        `branding/brandingbyappurl?appUrl=${encodeURIComponent(appUrl)}`
      );
      const branding: Branding = response.data;

      return branding;
    } catch (err) {
      throw err;
    }
  },
};

export default brandingService;
